export enum Platform {
  Apk = 'apk',
  Web = 'web',
  Huawei = 'huawei',
  Ios = 'ios',
}
